import { useState } from "react";
import {
    GoogleMap,
    InfoWindow,
    Marker,
    useLoadScript,
} from "@react-google-maps/api";
import * as React from "react";

const CandidateMarkerSVG = (index) => {
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="31" height="43" viewBox="0 0 31 43">
    <path id="Vector" d="M13.5848 42.1324C2.12682 24.4421 0 22.6265 0 16.125C0 7.21938 6.77876 0 15.1408 0C23.5029 0 30.2817 7.21938 30.2817 16.125C30.2817 22.6265 28.1549 24.4421 16.6969 42.1324C15.945 43.2892 14.3366 43.2892 13.5848 42.1324Z" fill="rgba(98, 117, 231, 0.6)"/>
    <g transform="translate(2.5, 3.03)">
      <rect x="0" y="0" rx="111.44" width="25" height="24" fill="white" fill-opacity="0.9"/>
      <text x="40%" y="30%" dominant-baseline="middle" text-anchor="middle" font-size="18" fill="#6275E7" font-family="Nunito" font-weight="800" fill-opacity="0.9">${index}</text>
    </g>
  </svg>`;

    const svgUrl = `data:image/svg+xml,${encodeURIComponent(svgString)}`;

    return {
        url: svgUrl,
        scaledSize: new window.google.maps.Size(31, 43),
        anchor: new window.google.maps.Point(15.5, 43),
    };
};
const createGoogleMarkerIcon = (opacity) => {
    const svgString = `
    <svg width="120" height="130" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_452_527)">
    <path d="M23.281 0.312591C23.3487 0.329749 23.4165 0.346907 23.4863 0.364585C24.3941 0.60165 25.2469 0.926064 26.0935 1.32822C26.1751 1.36588 26.2566 1.40355 26.3407 1.44235C28.0345 2.25129 29.698 3.51702 30.8591 5.00009C30.8922 5.0417 30.9252 5.0833 30.9593 5.12617C32.2963 6.81799 33.2292 8.68427 33.7497 10.7813C33.7662 10.8462 33.7826 10.9111 33.7995 10.9779C34.258 12.8741 34.2687 15.1285 33.8279 17.0313C33.8058 17.1309 33.8058 17.1309 33.7833 17.2324C33.3871 18.9758 32.642 20.5181 31.7064 22.032C31.5525 22.2815 31.4005 22.5321 31.2488 22.783C31.0255 23.1523 30.8016 23.5213 30.5771 23.8899C30.2685 24.3965 29.9605 24.9036 29.6527 25.4107C29.5145 25.6384 29.3763 25.8661 29.238 26.0938C29.1827 26.185 29.1273 26.2761 29.072 26.3673C24.7556 33.4767 24.7556 33.4767 24.6726 33.6134C24.6172 33.7045 24.5619 33.7957 24.5065 33.8869C24.3684 34.1144 24.2302 34.342 24.092 34.5695C23.8692 34.9365 23.6464 35.3035 23.4237 35.6704C23.3815 35.74 23.3815 35.74 23.3385 35.8109C23.2817 35.9044 23.2249 35.998 23.1681 36.0915C23.0285 36.3216 22.8888 36.5516 22.749 36.7816C22.4825 37.22 22.2167 37.6588 21.9526 38.0985C21.9031 38.1805 21.8537 38.2625 21.8028 38.347C21.7106 38.4999 21.6187 38.653 21.5272 38.8063C20.8873 39.8659 20.8873 39.8659 20.4685 40.0001C20.0712 40.0517 19.7197 40.0481 19.3503 39.8878C18.8527 39.4133 18.5266 38.7543 18.1736 38.169C17.7742 37.5098 17.3722 36.8523 16.9675 36.1964C16.5018 35.441 16.0399 34.6833 15.5801 33.9244C15.1809 33.2657 14.7791 32.6087 14.3747 31.9532C13.9138 31.2059 13.4568 30.4564 13.0019 29.7055C12.6027 29.0469 12.2009 28.39 11.7966 27.7345C11.3359 26.9875 10.8791 26.2384 10.4244 25.4878C10.0122 24.8075 9.59693 24.1292 9.17942 23.4522C8.79484 22.8284 8.41036 22.2047 8.03684 21.5742C7.94247 21.4157 7.84655 21.2582 7.74876 21.1018C5.99807 18.2491 5.43772 14.4399 6.15116 11.1787C6.18322 11.046 6.21607 10.9136 6.24973 10.7813C6.27547 10.6796 6.27547 10.6796 6.30173 10.5757C6.5388 9.66805 6.86327 8.81525 7.26536 7.96884C7.32186 7.84648 7.32186 7.84648 7.37949 7.72165C8.18843 6.0278 9.45416 4.36432 10.9372 3.20322C10.9788 3.17016 11.0204 3.1371 11.0633 3.10304C12.7555 1.76575 14.6213 0.834067 16.7185 0.312591C16.7829 0.296163 16.8474 0.279735 16.9138 0.262809C18.9233 -0.226765 21.2802 -0.199898 23.281 0.312591ZM14.9216 9.21884C13.4716 10.9385 12.8786 12.7568 13.0466 15.0001C13.2757 16.7969 14.2474 18.4655 15.6577 19.5957C17.2766 20.8288 19.2126 21.2366 21.2171 20.991C23.053 20.6644 24.7073 19.5798 25.777 18.0634C26.8222 16.427 27.2561 14.5001 26.8648 12.5747C26.382 10.5579 25.1697 9.04485 23.4372 7.94443C20.6896 6.37559 17.0968 6.94264 14.9216 9.21884Z" fill="rgba(255, 0, 0, ${opacity})"/>
    <path d="M19.9997 9.11802e-05C19.9997 2.34619 19.9997 4.69228 19.9997 7.10947C19.3036 7.18681 19.3036 7.18681 18.5935 7.26572C17.4317 7.57784 16.493 8.01015 15.5466 8.75009C15.4979 8.78584 15.4491 8.82159 15.3989 8.85843C14.1979 9.79282 13.3512 11.4726 13.1428 12.9511C12.9247 15.0492 13.3907 16.9577 14.729 18.6097C16.1136 20.2384 17.9109 20.7958 19.9997 21.0157C19.9997 27.2806 19.9997 33.5454 19.9997 40.0001C19.5009 39.9288 19.296 39.8922 18.9841 39.5313C18.8099 39.2798 18.6601 39.0168 18.5105 38.7501C18.4209 38.5945 18.3312 38.4389 18.2413 38.2835C18.196 38.2047 18.1506 38.1259 18.1039 38.0448C17.8978 37.6914 17.6822 37.3441 17.4656 36.9972C17.114 36.4327 16.7657 35.8664 16.4206 35.2979C16.0323 34.6585 15.6414 34.0207 15.2488 33.3839C14.7831 32.6285 14.3212 31.8708 13.8613 31.1119C13.4621 30.4532 13.0603 29.7962 12.656 29.1407C12.1951 28.3934 11.7381 27.6439 11.2831 26.893C10.884 26.2344 10.4821 25.5775 10.0779 24.922C9.47033 23.9365 8.86741 22.9483 8.2692 21.9572C8.14368 21.7501 8.0169 21.5439 7.88944 21.338C6.07511 18.3805 5.40698 14.5804 6.15116 11.1787C6.18322 11.046 6.21607 10.9136 6.24973 10.7813C6.27547 10.6796 6.27547 10.6796 6.30173 10.5757C6.5388 9.66805 6.86327 8.81525 7.26536 7.96884C7.32186 7.84648 7.32186 7.84648 7.37949 7.72165C8.18843 6.0278 9.45416 4.36432 10.9372 3.20322C10.9788 3.17016 11.0204 3.1371 11.0633 3.10304C13.0063 1.56757 15.1853 0.582024 17.6218 0.127044C17.689 0.113921 17.7562 0.100797 17.8255 0.0872761C18.5667 -0.0392647 19.2182 9.11802e-05 19.9997 9.11802e-05Z" fill="rgba(255, 0, 0, ${opacity})"/>
    </g>
    <defs>
    <clipPath id="clip0_452_527">
    <rect width="100" height="120" fill="white"/>
    </clipPath>
    </defs>
    </svg>
    `;

    const svgUrl = `data:image/svg+xml,${encodeURIComponent(svgString)}`;

    return {
        url: svgUrl,
        scaledSize: new window.google.maps.Size(41, 53),
        anchor: new window.google.maps.Point(15.5, 43),
    };
};

const CardMapHotel = ({ selectedElement }) => {
    return (
        <div
            style={{
                width: "100%",
                flex: "1 1 0",
                padding: "1px",
                borderRadius: "16px",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                gap: "8px",
                display: "inline-flex",
            }}
        >
            <div
                style={{
                    color: "#141933",
                    fontSize: "16px",
                    fontFamily: "Lato",
                    fontWeight: "700",
                    lineHeight: "24px",
                    wordWrap: "break-word",
                }}
            >
                {selectedElement?.name}
            </div>
            <div
                style={{
                    color: "#505573",
                    fontSize: "15px",
                    fontFamily: "Lato",
                    fontWeight: "400",
                    lineHeight: "16px",
                    wordWrap: "break-word",
                }}
            >
                {selectedElement?.address}, {selectedElement?.city},
                {selectedElement?.country}
            </div>
        </div>
    );
};

const CardMap = (props) => {
    const { candidates, data, center, activeMarker, setActiveMarker } = props;
    const [selectedElement, setSelectedElement] = useState(null);

    const styledMapType = [
        {
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }],
        },
    ];

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyD61FcrAi5dm8S8LQzAMaS-_W9Xsd2Y5UY",
    });

    if (!isLoaded) return <div>Loading...</div>;

    return (
        <GoogleMap
            zoom={19}
            center={center}
            mapContainerClassName="map-container"
            options={{
                styles: styledMapType,
                fullscreenControl: false,
                mapTypeControlOptions: true,
                panControl: false,
                streetViewControl: true,
                mapTypeControl: false,
                zoomControl: true,
                clickableIcons: true,
            }}
        >
            {candidates?.slice(0, 9)?.map((hotel, index) => {
                return (
                    <Marker
                        key={index}
                        position={{
                            lat: hotel.latitude,
                            lng: hotel.longitude,
                        }}
                        icon={CandidateMarkerSVG(index + 1)}
                        onClick={() => {
                            setSelectedElement(hotel);
                            setActiveMarker({
                                lat: hotel.latitude,
                                lng: hotel.longitude,
                            });
                        }}
                    />
                );
            })}

            <Marker
                key={data.hotel_code}
                position={{
                    lat: data.latitude,
                    lng: data.longitude,
                }}
                icon={createGoogleMarkerIcon(0.6)}
                onClick={() => {
                    setSelectedElement(data);
                    setActiveMarker({
                        lat: data.latitude,
                        lng: data.longitude,
                    });
                }}
            />

            {selectedElement && activeMarker && (
                <InfoWindow
                    position={activeMarker}
                    onCloseClick={() => {
                        setSelectedElement(null);
                        setActiveMarker(null);
                    }}
                >
                    <CardMapHotel selectedElement={selectedElement} />
                </InfoWindow>
            )}
        </GoogleMap>
    );
};

export default CardMap;
